import * as React from "react";
const SvgDot04 = props => <svg viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={3} cy={3} r={2.25} fill="currentColor" /></svg>;
export default SvgDot04;